import gql from 'graphql-tag';

const RemoveAssignments = gql(/* GraphQL */ `
  mutation RemoveAssignments($input: RemoveAssignmentsInput!) {
    removeAssignments(input: $input) {
      deliveryId
      userErrors {
        ... on UserError {
          message
        }
      }
    }
  }
`);

export default RemoveAssignments;
